function PlayIcon(props)
{
    return( 
        <svg className={props.class} viewBox="0 0 512 512"><g id="Play"><g id="Play-2" data-name="Play"><path d="M256,73.8206A182.1794,182.1794,0,1,0,438.18,256,182.1821,182.1821,0,0,0,256,73.8206Zm67.8249,192.2167L218.7,326.7342a10.3757,10.3757,0,0,1-15.5655-8.991V196.3574a10.38,10.38,0,0,1,15.5745-8.991l105.1254,60.697a10.3756,10.3756,0,0,1-.009,17.9739Z"/></g></g></svg>
    )
}

export default PlayIcon